import { Nullable, StaticContent } from 'shared/types';

export const FETCH_STATIC_CONTENT_INIT = 'FETCH_STATIC_CONTENT_INIT';
export const FETCH_STATIC_CONTENT_SUCCESS = 'FETCH_STATIC_CONTENT_SUCCESS';
export const FETCH_STATIC_CONTENT_ERROR = 'FETCH_STATIC_CONTENT_ERROR';

export interface StaticContentState {
  loading: boolean;
  data: StaticContent;
  error: Nullable<string>;
}

interface FetchStaticContent {
  type: typeof FETCH_STATIC_CONTENT_INIT;
}

interface FetchStaticContentSuccess {
  type: typeof FETCH_STATIC_CONTENT_SUCCESS;
  data: StaticContent;
}

interface FetchStaticContentError {
  type: typeof FETCH_STATIC_CONTENT_ERROR;
  error: string;
}

export type StaticContentActionTypes =
  | FetchStaticContent
  | FetchStaticContentSuccess
  | FetchStaticContentError;
